import { Button, CInputControl } from "core/components/form-controls";
import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import {useCustomNavigate } from "core/hooks/useCustomNavigate";
import { RouterName, route } from "core/router";
import { useFormikCustom } from "core/hooks/useFormikCustom";
import { getFieldInputProps } from "core/utils/form";
import { _t } from "core/language";
import { validationSchemaForm} from "./Auth.config";
import { useDataFormSave } from "../hooks";
import { API_RESET_PASSWORD } from "../api";
import API from "core/networks/API";
import { useEffect, useRef } from "react";


const ForgotPwForm = () => {
  const navigate = useCustomNavigate();
  const dataFormSave = useDataFormSave()
  
  const formik = useFormikCustom({
    initialValues: {
      email: dataFormSave?.email,
      password: "",
      rePassword: "",
      temporary_password: dataFormSave?.temporary_password,
      validSubmit:false
    },
    validationSchema:validationSchemaForm,
    validateOnMount: false, // Prevent validation on page load (default behavior)
    validateOnChange: false, // Validate on field changes
    validateOnBlur: false,   // Validate when a field is blurred
    onSubmit(values, formikHelpers) {
      console.log(values, formikHelpers)
      
      handleResetPassword()
      setTimeout(() => {
        formikHelpers.setSubmitting(false)
      }, 2000)
    },
  });

  const formikRef = useRef(formik);
  useEffect(() => {
    formikRef.current = formik;
  }, [formik]);

  useEffect(() => {
    const isValidSubmit = !!(formikRef.current.values.password && 
      formikRef.current.values.rePassword && 
      formikRef.current.values.email);
    // const isValidSubmitError = (formikRef.current.errors.password || 
    //   formikRef.current.errors.rePassword || 
    //   formikRef.current.errors.email);
    // if (isValidSubmitError) {
    //   formikRef.current.setFieldValue('validSubmit', false);
    //   return
    // }
    if (formikRef.current.values.validSubmit !== isValidSubmit) {
      formikRef.current.setFieldValue('validSubmit', isValidSubmit);
    }
  }, [formik.values.email, formik.values.password, formik.values.rePassword, formik.errors]);

  
  const handleGoBack = () => {
    navigate(route(RouterName.FORGOT_PW_CHECK_MAIL))
  }

  const handleResetPassword = async () => {

    const dataRequest = {
      email: formik.values.email,
      temporary_password: formik.values.temporary_password,
      password: formik.values.password,
      
    }
    try {
      const { data: response } = await API.post(`${API_RESET_PASSWORD}`, dataRequest)
      if (response && response?.code === 200) {
        localStorage.setItem('forgotPw', JSON.stringify(dataRequest))
        navigate(route(RouterName.LOGIN))
      }
    } catch (e: any) {
      console.log(e,'errors');
      
      //
    }
  }

  const handleSubmit = (e: any) => {
    const { onSubmit, errors } = formik;
    console.log(errors,'errors')
    onSubmit(e)
  };
  
  return (
    <AppLayout className={"login-client-page"}>
      <PageHeader sticky showCart={false} title={_t('auth.LabelResetPassword')} handleGoBack={handleGoBack} />
      <div className="mt-1">
        <form onSubmit={handleSubmit} className="flex flex-col px-4 py-12 w-full tracking-tighter bg-white">
          <div className="">
          <CInputControl
              label={_t('auth.NewPassword')}
              error=""
              maxLength={200}
              type="password"
              placeholder={_t('auth.PlaceHolderPassword')}
              {...getFieldInputProps(formik, 'password')}
            />
            <CInputControl
              label={_t('auth.ConfirmNewPassword')}
              error=""
              maxLength={200}
              type="password"
              placeholder={_t('auth.PlaceHolderConfirmPassword')}
              {...getFieldInputProps(formik, 'rePassword')}
            />
          </div>
          <div className="absolute left-0 bottom-0 w-full px-4">
            <Button disabled={!formik.values.validSubmit} size="lg" type="submit" label={_t('auth.Confirm')}  classBtn="w-full mb-[50px] hover:bg-white focus:bg-white" />
          </div>
        </form>
      </div >

    </AppLayout >
  );
};

export default ForgotPwForm;
